"use client";

import * as React from "react";

// Simple tooltip implementation without Radix UI dependencies
function TooltipProvider({ children, delayDuration = 0 }: { children: React.ReactNode; delayDuration?: number }) {
  return <>{children}</>;
}

function Tooltip({ children }: { children: React.ReactNode }) {
  // Wrap trigger + content so we can control visibility with CSS (group hover)
  return <div className="relative inline-block group">{children}</div>;
}

function TooltipTrigger({ 
  children, 
  asChild,
  ...props 
}: { 
  children: React.ReactNode;
  asChild?: boolean;
  [key: string]: any;
}) {
  if (asChild) {
    // When asChild is true, just return the children directly
    return <>{children}</>;
  }
  return (
    <div data-slot="tooltip-trigger" {...props}>
      {children}
    </div>
  );
}

function TooltipContent({ 
  children, 
  className = "",
  sideOffset = 0,
  ...props 
}: { 
  children: React.ReactNode;
  className?: string;
  sideOffset?: number;
  [key: string]: any;
}) {
  // Positioned tooltip content that becomes visible when the parent .group is hovered/focused
  return (
    <div
      data-slot="tooltip-content"
      role="tooltip"
      className={`pointer-events-none invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-150 bg-gray-900 text-white text-xs px-2 py-1 rounded-md shadow-lg z-50 whitespace-nowrap absolute left-1/2 transform -translate-x-1/2 -translate-y-full ${className}`}
      style={{ marginBottom: `${sideOffset}px` }}
      {...props}
    >
      {children}
    </div>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };